import {
  Tournament,
  TournamentPhase,
} from 'functions/src/types/firestore/Game/Tournament';
import { Token } from '../../../functions/src/types/firestore/User/Payout';

export const PHASE_PRIORITY: Record<TournamentPhase, number> = {
  unpublished: 0,
  ready: 1,
  live: 2,
  checkIn: 3,
  registration: 4,
  finished: 5,
  payout: 6,
};

export const sortTournaments = <
  TTournament extends Pick<
    Tournament<Date>,
    'id' | 'phase' | 'payouts' | 'date'
  >,
>(
  formatTotal: (
    payouts: {
      tokens: Token[];
    }[],
  ) => {
    amountFiat: number;
    countItems: number;
  },
  tournaments: TTournament[],
) => {
  return tournaments.sort((tournamentA, tournamentB) => {
    const {
      phase: phaseA,
      payouts: payoutsA,
      date: dateA,
      id: idA,
    } = tournamentA;
    const {
      phase: phaseB,
      payouts: payoutsB,
      date: dateB,
      id: idB,
    } = tournamentB;
    const phaseDiff =
      PHASE_PRIORITY[String(phaseA)] - PHASE_PRIORITY[String(phaseB)];
    if (phaseDiff !== 0) return phaseDiff;
    const prizeA = formatTotal(payoutsA);
    const prizeB = formatTotal(payoutsB);
    const prizeDiff = prizeB.amountFiat - prizeA.amountFiat;
    if (prizeDiff !== 0) return prizeDiff;

    const timeDiff = dateA.getTime() - dateB.getTime();
    if (timeDiff !== 0) return timeDiff;

    return idA.localeCompare(idB);
  });
};
